import React, {Component} from "react";  import config from 'react-global-configuration';
import "react-tabs/style/react-tabs.css";
import jwt_decode from "jwt-decode";
import axios from "axios";
import $ from "jquery";
import 'datatables.net-fixedcolumns';
import {css} from "@emotion/core";
import * as moment from "moment";
import {connect}  from  "react-redux";
import loadingGif from "../../assets/img/loading.gif";
import {BeatLoader} from "react-spinners";
import {confirmAlert} from 'react-confirm-alert';
import { isApiResponse, isReportAccess, date_range_config, aplloClient, user_activities } from '../../helpers/utils.js';
import DownloadAllReport from '../DownloadReport/DownloadAllReport.jsx';
import ModalD from "react-awesome-modal";

const override = css `
    display: block;
    margin: 0 auto;
    border-color: red;
    text-align:center;
`;
var date_config = date_range_config('30', '0', '2020-02-01','0');
var ReportTable='';
var timestamp  = new Date().getTime();
class KotakAxisBtidReport extends Component{
    constructor(props) {
        super(props);
        this.state ={
            datefrom:date_config.start_date,
            dateTo:date_config.end_date,
            datefromShow:date_config.display_start_date,
            dateToShow:date_config.display_end_date,
            yestSend:date_config.start_date_value,
            todSend:date_config.end_date_value,
            dateFromLimit: date_config.start_date_limit,
            dateLimit:date_config.end_date_limit,
            ciutidIds: '',
            loading:false,
            isChange: false,
            object_code:[],
            state_code:"",
            tableHeaders:[],
            tableBody:[],
            bank_names:"",
            download_limit:31,
            merchant_names:'',
            isSubmit:false,
            selectedFile:'',
            is_record: false,
            bank:'',
            report:''
        }

    }
    componentWillMount() {
        this.props.currentMenu("unipaynext");
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        const tokenPermission = localStorage.userPermission;
        const decoded_permission = jwt_decode(tokenPermission);
        let AllAccessPermissions = decoded_permission.accessPermissions;
        isReportAccess(AllAccessPermissions, "kotak_axis_btid_report");
        var stringCode = decoded.object_code;
        var arrayCode = stringCode.split(",");



        if(decoded.object_type==='Merchant'){
            this.setState({
                merchantID: arrayCode
            })
        }
        if(decoded.object_type==='Chain'){
            this.setState({
                chainID: arrayCode
            })
        }
        if(decoded.object_type==='Store'){
            this.setState({
                storeID: arrayCode
            })
        }

        this.setState({
            user_id:decoded._id,
            object_type: decoded.object_type,
            object_code: arrayCode,
            userType: decoded.userType,
        });


    }
    componentDidUpdate() {

    }
    componentDidMount() {
        //this.get_download_limit();
        //this.get_filtered_report('');
        user_activities(0, jwt_decode(localStorage.usertoken)._id, jwt_decode(localStorage.usertoken).firstName+' '+jwt_decode(localStorage.usertoken).lastName, jwt_decode(localStorage.usertoken).email,'live_transaction_dump_report','sparcs')

    }
    downLoadKotakAxisBtidReport (e){
        var that = this;

        this.setState({
            is_download: false,
            model_visible: true,
            file_url: '',
            rfile: '',
            fetch_data:false
        });
        const formData = new FormData();
        const timestamp = Date.now();
        formData.append('file', this.state.selectedFile);
        formData.append('random_string', timestamp);
        formData.append('rows_per_page', 20);
        formData.append('page_number', 1);
        formData.append('search_query', '');
        formData.append('order', '-1');
        formData.append('order_type', 'desc');
        formData.append('bank', this.state.bank);
        formData.append('start_date', this.state.yestSend);
        formData.append('end_date', this.state.todSend);
        formData.append('download', 1);
        formData.append('report_code', this.state.report);
        formData.append('user_id', this.state.user_id);
        formData.append('merchant_names', this.state.merchant_names);


        let xhrBank = $.ajax({
            url:config.get('API_URL')+ "/InternalReport/upload_input_files",
            type: "POST",
            data: formData,
            processData: false,
            contentType: false,
            beforeSend: function (request) {
                request.setRequestHeader("Authorization", localStorage.usertoken);
            },
//             xhrFields: {
//                 responseType: 'blob'
//             },
            success: function (response, status, xhr) {
                this.copyFiles(response.data);
                this.setState({
                    fetch_data:true
                })
            }.bind(this),
            error: function(data) {
                that.closeModal();
                alert("Failed to download data. Please try again");
            }
        });
        this.setState({
            xhrBank: xhrBank
        })

    }
    copyFiles(remotePath){
        var that = this;
        var postData = {
            remotePath: remotePath
        }


        let xhrBank = $.ajax({
            url:config.get('API_URL')+ "/reports/copy-file",
            type: "POST",
            data: postData,
            beforeSend: function (request) {
                request.setRequestHeader("Authorization", localStorage.usertoken);
            },
            xhrFields: {
                responseType: 'blob'
            },
            success: function (response, status, xhr) {
                let blob = new Blob([response], {
                    type: "octet/stream"
                });
                let fileName = timestamp+that.state.report+'.csv.gz';
                let rfile = fileName.replace(/\"/g, "");
                //console.log(fileName)
                //let a = document.createElement('a');
                let url = window.URL.createObjectURL(blob);
                // a.href = url;
                // a.download = rfile;
                // a.click();
                // window.URL.revokeObjectURL(url);
                this.setState({
                    is_download: true,
                    file_url: url,
                    rfile: rfile
                })
            }.bind(this)
        });
        this.setState({
            xhrBank: xhrBank
        })

    }
    downloadFile(e){
        let a = document.createElement('a');
        a.href = this.state.file_url;
        a.download = this.state.rfile;
        a.click();
        window.URL.revokeObjectURL(this.state.url);
    }



    get_filtered_report(e) {
    var that = this;
    if (this.state.bank == null || this.state.bank == '') {
        alert("Please select Bank");
        return false;
    }
    if (this.state.report == null || this.state.report == '') {
        alert("Please select Report");
        return false;
    }
    if (this.state.selectedFile == null || this.state.selectedFile == '') {
        alert("Please upload a valid CSV file first");
        return false;
    }
    this.setState({
        is_record:false,
        loading:true
    })
    const formData = new FormData();
    const timestamp = Date.now();
    formData.append('file', this.state.selectedFile);
    formData.append('random_string', timestamp);
    formData.append('rows_per_page', 20);
    formData.append('page_number', 1);
    formData.append('search_query', '');
    formData.append('order', '-1');
    formData.append('order_type', 'desc');
    formData.append('bank', this.state.bank);
    formData.append('start_date', this.state.yestSend);
    formData.append('end_date', this.state.todSend);
    formData.append('download', 0);
    formData.append('report_code', this.state.report);
    formData.append('user_id', this.state.user_id);
    formData.append('merchant_names', this.state.merchant_names);

    if ($.fn.DataTable.isDataTable('#ReportTable')) {
        $('#ReportTable').DataTable().clear().destroy();
        $('#ReportTable thead').empty();
    }

    $.ajax({
        url: config.get('API_URL') + "/InternalReport/upload_input_files",
        type: "POST",
        data: formData,
        contentType: false,
        processData: false,
        beforeSend: function (request) {
            request.setRequestHeader("Authorization", localStorage.usertoken);
        },
        success: function (response) {
            isApiResponse(true);
            that.setState({ isChange: false });

            if (response.data && response.data.length > 0) {

                var columns = Object.keys(response.data[0]).map(function (key) {
                    return { data: key, title: key };
                });

                that.setState({
                    is_record:true,
                    loading:false
                })
                var headerRow = '';
                columns.forEach(function (col) {
                    headerRow += `<th>${col.title}</th>`;
                });
                $('#ReportTable thead').html(`<tr>${headerRow}</tr>`);


                ReportTable = $('#ReportTable').DataTable({
                    order: [],
                    processing: true,
                    serverSide: false,
                    paging: true,
                    pageLength: 20,
                    autoWidth: true,
                    responsive: false,
                    searching: true,
                    scrollX: true,
                    lengthMenu: [[20, 50, 100, 500, -1], [20, 50, 100, 500, "All"]],
                    data: response.data,
                    columns: columns
                });
            } else {
                that.setState({
                    is_record:false,
                    loading:false
                })
                alert("No data found in API response.");

            }
        },
        error: function (err) {
         console.error("Error response:", err);

    let errorMessage = "Failed to load data. Please try again.";

    if (err.responseJSON && err.responseJSON.message) {
        errorMessage = "Error: " + err.responseJSON.message; // Flask error
    } else if (err.responseText) {
        try {
            const errorData = JSON.parse(err.responseText);
            if (errorData.message) {
                errorMessage = "Error: " + errorData.message;
            }
        } catch (e) {
            console.error("Error parsing responseText:", e);
        }
    }

    alert(errorMessage);

    that.setState({
        is_record: false,
        loading: false
    });
}
    });
}


    reset_all(e){
        setTimeout(function(){
            this.componentWillMount()
            this.componentDidMount()
        }.bind(this), 200);
    }

    handleMerchant = (optionSelected, merchant_names) =>
    {
        this.setState({
            merchant_names:merchant_names,
            isChange: true
        });
    }
    changeBank(e) {
        this.setState({
            bank : e.target.value
        })
    }
    changeReport(e) {
        this.setState({
            report : e.target.value
        })
    }
    getFileExtension(filename) {
    return filename.split('.').pop().toLowerCase();
}

onChangeHandler = (event) => {
    const file = event.target.files[0];
    const ext = this.getFileExtension(file.name);

    if (ext === 'csv') {
        this.setState({
            selectedFile: file
        });
    } else {
        this.handleNotificationClick("tr", 3, "Please upload a valid CSV file");
        this.setState({
            selectedFile: null // Clear invalid file
        });
    }
};

fileUploadHandler = () => {
    if (this.state.selectedFile === null) {
        this.handleNotificationClick("tr", 3, "Please upload a valid CSV file first");
        return false;
    }

    this.setState({
        isSubmit: true,
        loading: true
    });

    const token = localStorage.usertoken;
    const decoded = jwt_decode(token);
    const data = new FormData();
    data.append('file', this.state.selectedFile);
    data.append('userID', decoded.email);

    // ✅ Since only CSV is allowed, no need to check extension again
    axios.post(config.get('API_URL') + "/InternalReport/upload_input_files/", data, {
        headers: {
            Authorization: `${localStorage.usertoken}`
        }
    })
    .then(res => {
        if (res.data.success) {
            this.handleNotificationClick("tr", 1, res.data.success);
        } else {
            this.handleNotificationClick("tr", 3, res.data.error);
        }
        this.setState({ isSubmit: false, loading: false });
    })
    .catch(err => {
        this.handleNotificationClick("tr", 3, "Something went wrong!");
        this.setState({ isSubmit: false, loading: false });
    });
};
    closeModal() {
        this.setState({
            model_visible : false
        });
    }
    render() {
        return(
            <div className="content-invoice">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card">
                                <div className="col-md-9 no-padd">
                                    <div className="header">
                                        <h4 className="title"></h4>
                                        <p className="category"></p>
                                    </div>
                                </div>
                                <div className="col-md-3 pull-right">
                                    <div className="r-p-menu">
                                        {/*<SalesMenu></SalesMenu>*/}
                                    </div>
                                </div>
                                <div className = "clearfix"></div>
                                <div className = "content">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="col-md-2 filter-bottom5 padd-5 date-icon-small">
                                                <div><label>Select Bank </label></div>
                                                <select name="bank" className="form-control"
                                                            value={this.state.bank}
                                                            onChange={this.changeBank.bind(this)}
                                                    >
                                                        <option value="">Select</option>
                                                        <option value="Axis">Axis</option>
                                                        <option value="Kotak">Kotak</option>

                                                    </select>
                                            </div>

                                                <div className="col-md-2 filter-bottom5 padd-5">
                                                  <label> Select Report </label>
                                                  <select
                                                    name="report"
                                                    className="form-control"
                                                    value={this.state.report}
                                                    onChange={this.changeReport.bind(this)}
                                                  >
                                                    <option value="">Select</option>

                                                    {this.state.bank === 'Axis' ? (
                                                      <>
                                                        <option value="Axis_Installation_Done">Installation Done</option>
                                                        <option value="Axis_Installation_Pending">Installation Pending</option>
                                                      </>
                                                    ) : this.state.bank === 'Kotak' ? (
                                                      <>
                                                        <option value="Kotak_Installation_Done">Installation Done</option>
                                                        <option value="Kotak_Installation_Pending">Installation Pending</option>
                                                        <option value="Kotak_De_Installation_Pending">De-Installation Pending</option>
                                                        <option value="Kotak_De_Installation_Completed">De-Installation Completed</option>
                                                      </>
                                                    ) : null}
                                                  </select>
                                                </div>

                                            <div className="col-md-2 filter-bottom5 padd-5">
                                                <label htmlFor="queryName" className="">Upload Your Csv FIle</label>
                                                <input type="file" name="file" className="form-control-file" onChange={this.onChangeHandler} />
                                            </div>
                                        </div>

                                    </div>
                                    <div className="row">
                                        <div className="col-md-5 pull-right">
                                            <button type="button" className="primary apply-filter" role="button" onClick={this.get_filtered_report.bind(this)} disabled={this.state.isSubmit}>Generate the Report</button>
                                        </div>
                                    </div>
                                    <div className="clearfix"></div>
                                    <div className="row">
                                        <div className="ro-sep"></div>
                                    </div>
                                    <BeatLoader
                                        css={override}
                                        sizeUnit={"px"}
                                        size={20}
                                        color={'#123abc'}
                                        loading={this.state.loading}
                                    />
                                    {this.state.is_record===true ?
                                    <div>
                                        <div className="">
                                            <a href="#" className="exportButton" role="button" onClick={this.downLoadKotakAxisBtidReport.bind(this)}>
                                                <i className="fa fa-download" aria-hidden="true"></i>
                                                Export to CSV
                                            </a>
                                        </div>
                                        <div className="clearfix"></div>

                                        <div className="content-tdetails-table table-full-width marginTop0">
                                            <table id="ReportTable" className="table table-striped table-hover">
                                                <thead>

                                                </thead>
                                                <tbody>

                                                </tbody>
                                            </table>
                                        </div>
                                    </div> :null}
                                    <ModalD visible={this.state.model_visible} width="300" height="100" effect="fadeInUp">
                                        <div className="download-popup-model">
                                            <div className="message-content">
                                                {this.state.file_url==''?
                                                    <div>
                                                        {this.state.fetch_data===false?
                                                        <p>Fetching Data & Generating CSV...</p>:<p>Fetching File. Please wait...</p>}
                                                        <a href="javascript:void(0);" onClick={() => this.closeModal()}>
                                                            <i className="fa fa-times-circle" aria-hidden="true"></i>Cancel
                                                        </a>
                                                    </div>

                                                    :
                                                    <div className="dwnloadLink">
                                                        <a href="#" onClick={this.downloadFile.bind(this)}>
                                                            <i className="fa fa-download" aria-hidden="true"></i>Download
                                                        </a>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                        <a href="javascript:void(0);" onClick={() => this.closeModal()}>
                                                            <i className="fa fa-times-circle" aria-hidden="true"></i>Close
                                                        </a>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    </ModalD>

                                    <div className="footer">
                                        <div className="stats"><i></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        );
    }
}

const mapDispatchToProps = (dispatch) =>{
    return {
        currentMenu: (name)=>{dispatch({type:'change_menu',payload:name})}
    }
}
export default connect(null,mapDispatchToProps)(KotakAxisBtidReport)